var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: -974.482,
    y1: 1306.773,
    x2: -622.378,
    y2: 1658.877,
    gradientTransform: "matrix(0.096395,0,0,0.0943868,100.964633,-116.459102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(14.117647%,53.72549%,74.509804%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(1.960784%,45.882353%,70.196078%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 24 0 C 10.746094 0 0 10.519531 0 23.5 C 0 36.480469 10.746094 47 24 47 C 37.253906 47 48 36.480469 48 23.5 C 48 10.519531 37.253906 0 24 0 Z M 17.597656 34.859375 L 12.328125 34.859375 L 12.328125 18.191406 L 17.597656 18.191406 Z M 14.9375 16.007812 C 13.214844 16.007812 11.820312 14.632812 11.820312 12.933594 C 11.820312 11.234375 13.214844 9.855469 14.9375 9.855469 C 16.65625 9.855469 18.054688 11.234375 18.054688 12.933594 C 18.054688 14.632812 16.65625 16.007812 14.9375 16.007812 Z M 37.34375 34.859375 L 32.101562 34.859375 L 32.101562 26.109375 C 32.101562 23.710938 31.167969 22.371094 29.230469 22.371094 C 27.121094 22.371094 26.019531 23.765625 26.019531 26.109375 L 26.019531 34.859375 L 20.964844 34.859375 L 20.964844 18.191406 L 26.019531 18.191406 L 26.019531 20.4375 C 26.019531 20.4375 27.539062 17.683594 31.148438 17.683594 C 34.761719 17.683594 37.34375 19.839844 37.34375 24.304688 Z M 37.34375 34.859375 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon2);
export default __webpack_public_path__ + "static/media/linkedin-icon (2).13ad23157260e7ec494bd194b696bd2f.svg";
export { ForwardRef as ReactComponent };